import { fillPath, sendJson } from '@/core/api/http'
import { apiGetOne, type TeilnahmeAufgabe } from '@/core/api/resources'
import { formatDatum } from '@/core/lib/dates'
import { WOCHENTAGE } from '@/core/lib/kalenderZeitraum'

export type { TeilnahmeAufgabe } from '@/core/api/resources'

export function listAufgaben(coachingId: string): Promise<TeilnahmeAufgabe[]> {
  return apiGetOne('/vergabe-portal/coaching/{coaching_id}/aufgaben', { coaching_id: coachingId })
}

export const dokumentationSpeichern = (aufgabeId: string, neu: boolean, eingabe: { datum: string; text: string }): Promise<{ drin?: boolean }> =>
  sendJson(fillPath('/vergabe-portal/aufgaben/{aufgabe_id}/dokumentation', { aufgabe_id: aufgabeId }), neu ? 'POST' : 'PATCH', eingabe)

export const nachFaelligkeit = (a: TeilnahmeAufgabe, b: TeilnahmeAufgabe): number =>
  a.faellig_am.localeCompare(b.faellig_am) || a.faellig_um.localeCompare(b.faellig_um)

export const faelligText = ({ faellig_am, faellig_um }: TeilnahmeAufgabe): string =>
  `${WOCHENTAGE[new Date(`${faellig_am}T00:00:00Z`).getUTCDay()]}, ${formatDatum(faellig_am)} · ${faellig_um}`

export const zustaendigText = ({ zugewiesen_an, zugewiesen_name }: TeilnahmeAufgabe): string =>
  zugewiesen_an === null ? "niemand zuständig" : zugewiesen_name ?? "Unbekannt"
